/**
 * D'Aboville-nummering voor nakomelingen-overzichten (spec §9).
 *
 * Standaard genealogie-conventie: proband = "1", eerste kind = "1.1", tweede
 * kind = "1.2", kleinkinderen = "1.1.1", "1.1.2", "1.2.1", etc.
 *
 * Pure function: zelfde input → zelfde output.
 */

export interface DabovilleNode<T = unknown> {
  id: string;
  children: DabovilleNode<T>[];
}

export function assignDabovilleNumbers<T>(root: DabovilleNode<T>): Map<string, string> {
  const result = new Map<string, string>();
  const walk = (node: DabovilleNode<T>, num: string): void => {
    result.set(node.id, num);
    node.children.forEach((child, idx) => {
      walk(child, `${num}.${idx + 1}`);
    });
  };
  walk(root, '1');
  return result;
}
